import { toDisplayString as _toDisplayString, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-622b0675"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal",
  tabindex: "-1",
  role: "dialog"
}
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title d-flex flex-row align-items-center",
  style: {"flex":"1"}
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "sidebar" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { class: "config" }
const _hoisted_13 = {
  key: 0,
  class: "loading d-flex flex-row align-items-center justify-content-center mt-5"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spinner fa-spin fa-2x" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "readonly"
}
const _hoisted_17 = { class: "modal-footer" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_object_config = _resolveComponent("object-config")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.object.title) + " ", 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.description) = $event)),
              class: "form-control d-inline ms-4",
              style: {"background-color":"transparent","flex":"1"},
              placeholder: "write an optional description"
            }, null, 512), [
              [_vModelText, _ctx.description]
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.objectConfig && _ctx.objectConfig.helpText && _ctx.objectConfig.helpText.title)
              ? (_openBlock(), _createElementBlock("h6", _hoisted_8, _toDisplayString(_ctx.objectConfig.helpText.title), 1))
              : _createCommentVNode("", true),
            (_ctx.objectConfig && _ctx.objectConfig.helpText && _ctx.objectConfig.helpText.text)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.objectConfig.helpText.text), 1))
              : _createCommentVNode("", true),
            (_ctx.componentHelpText && _ctx.componentHelpText.title)
              ? (_openBlock(), _createElementBlock("h6", _hoisted_10, _toDisplayString(_ctx.componentHelpText.title), 1))
              : _createCommentVNode("", true),
            (_ctx.componentHelpText && _ctx.componentHelpText.text)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.componentHelpText.text), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
              : (_ctx.objectConfig)
                ? (_openBlock(), _createBlock(_component_object_config, _mergeProps({
                    key: 1,
                    ref: "configComponent"
                  }, _ctx.objectConfig, {
                    object: _ctx.object,
                    modelValue: _ctx.object.config,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.object.config) = $event)),
                    onDependencyChange: _ctx.dependencyChanged,
                    onHelptext: _ctx.onHelpText
                  }), null, 16, ["object", "modelValue", "onDependencyChange", "onHelptext"]))
                : _createCommentVNode("", true),
            (_ctx.readonly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-transparent",
            "data-dismiss": "modal",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('view-object-logs')))
          }, "Show logs"),
          _hoisted_18,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light",
            "data-dismiss": "modal",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
          }, "Cancel"),
          (!_ctx.readonly)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-success",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.save()))
              }, "OK"))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}